import Vue from 'vue'
import Router from 'vue-router'
import loginView from 'views/login'
import usersView from 'views/users'
import customersView from 'views/customers'
import priceListsView from 'views/priceLists'
import overviewView from 'views/overview'
import ordersPrintView from 'views/ordersPrint'
import deliveryNotesPrintView from 'views/deliveryNotesPrint'
import ordersView from 'views/orders'
import reportsView from 'views/reports'
import areasView from 'views/areas'
import productsView from 'views/products'
import profileView from 'views/profile'
import profileEditView from 'views/profileEdit'
import invoiceDataPrintView from 'views/invoiceDataPrint'
import passwordChangeView from 'views/passwordChange'

Vue.use(Router);

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/overview'
    },
    {
      name: 'login',
      path: '/login',
      component: loginView,
      meta: {
        bodyClass: 'login-page'
      }
    },
    {
      path: '/overview',
      name: 'overview',
      component: overviewView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/orders/print',
      component: ordersPrintView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/delivery-notes/print',
      component: deliveryNotesPrintView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/invoice-data/print',
      component: invoiceDataPrintView,
      meta: {
        requiresLoggedIn: true,
        requiresSomeRole: ['ADMIN','DEALER']
      }
    },
    {
      path: '/orders',
      component: ordersView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/reports',
      component: reportsView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/profile',
      component: profileView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/profile-edit',
      component: profileEditView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/password-change',
      component: passwordChangeView,
      meta: {
        requiresLoggedIn: true
      }
    },
    {
      path: '/users',
      component: usersView,
      meta: {
        requiresLoggedIn: true,
        requiresRole: 'ADMIN'
      }
    },
    {
      path: '/customers',
      component: customersView,
      meta: {
        requiresLoggedIn: true,
        requiresRole: 'ADMIN'
      }
    },
    {
      path: '/price-lists',
      component: priceListsView,
      meta: {
        requiresLoggedIn: true,
        requiresRole: 'ADMIN'
      }
    },
    {
      path: '/areas',
      component: areasView,
      meta: {
        requiresLoggedIn: true,
        requiresRole: 'ADMIN'
      }
    },
    {
      path: '/products',
      component: productsView,
      meta: {
        requiresLoggedIn: true,
        requiresRole: 'ADMIN'
      }
    },
    {
      path: '/*',
      redirect: '/'
    }
  ]
});

export default router;




// WEBPACK FOOTER //
// ./client/router/index.js